export function convertToValueOpt(values) {
    return values.map((value) => {
        return { value: value, label: value };
    });
}
//# sourceMappingURL=SelectUtil.js.map